<template>
  <div>
    <!--  首页顶部导航栏 --PC端  -->
    <PCNavbar selectIndex="1"/>
    <!--  首页顶部导航栏 --移动端端  -->
    <MobileNavBar :currentActive="0"/>
    <!--  首页banner轮播图  -->
    <TopBanner />
    <!--  首页map地图  -->
    <Map/>
    <!--  产品展示  -->
    <ProductShow/>

    <MobileProductShow/>
    <!--   旗下品牌、品牌视频、新闻中心   -->
    <BrandAndNews/>
    <!--  里程碑  -->
    <Milestone/>
    <!--  公司地址及页脚  -->
    <CallMe/>
  </div>
</template>

<script>
import PCNavbar from '@/views/home/navbar/index.vue'
import MobileNavBar from '@/views/home/navbar/MobileNavBar.vue'
import TopBanner from '@/views/home/top_banner/index.vue'
import Map from '@/views/home/map/index.vue'
import ProductShow from '@/views/home/product_show/index.vue'
import MobileProductShow from '@/views/home/product_show/mobileIndex.vue'
import BrandAndNews from '@/views/home/brand_news/index.vue'
import CallMe from '@/views/home/callme/index.vue'
import Milestone from "@/views/home/milestone/index.vue";
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    TopBanner,
    Map,
    ProductShow,
    MobileProductShow,
    BrandAndNews,
    Milestone,
    CallMe
  },
}
</script>

<style lang="scss" scoped>
</style>